import { IGetGeneralFaqsDTO } from '@/models/generalFaq.model';
import { PaginationFields } from '@/models/pagination.model';

class GetGeneralFaqsDTO implements IGetGeneralFaqsDTO {
  question?: string;

  answer?: string;

  [PaginationFields.PAGE]?: number;

  [PaginationFields.PAGE_SIZE]?: number;

  constructor({ page = 1, question, answer }: { page?: number; question?: string; answer?: string } = {}) {
    if (question) {
      this.question = question;
    }
    if (answer) {
      this.answer = answer;
    }
    this[PaginationFields.PAGE] = page;
    this[PaginationFields.PAGE_SIZE] = 10;
  }
}

export default GetGeneralFaqsDTO;
